import { Inject, Injectable } from "@angular/core";
import { API_ENDPOINT_RESOLVER, IApiEndpointResolver } from "@mobile-data-access-resolvers";
import { HttpClient } from "@angular/common/http";
import { map, mergeMap, Observable } from "rxjs";
import { IAppointmentService } from "./appointment-service.interface";
import { IApiResult } from "@shared-interfaces";
import { AppointmentContainerCodes } from "@mobile-data-access-enums";

@Injectable()
export class AppointmentService implements IAppointmentService {
  //#region Constructor

  public constructor(
    @Inject(API_ENDPOINT_RESOLVER)
    protected readonly _apiEndpointResolver: IApiEndpointResolver,
    protected readonly _httpClient: HttpClient
  ) {}

  //#endregion

  //#region Chemo

  public getChemoAsync<T>(id: string, code: AppointmentContainerCodes): Observable<T> {
    return this._getDataAsync<T>(code, id);
  }

  //#endregion Chemo

  //#region Methods

  protected _getDataAsync<T>(controlCode: string, id: string): Observable<T> {
    return this._apiEndpointResolver.loadEndPointAsync('', '').pipe(
      mergeMap((baseUrl) => {
        const apiUrl = `${baseUrl}/appointment/detail/${controlCode}`;
        const httpParams: Record<string, string> = {};
        httpParams['id'] = id;

        return this._httpClient
          .get<IApiResult<T>>(apiUrl, { params: httpParams })
          .pipe(map(({ data }) => data));
      })
    );
  }

  //#endregion
}
